module.exports = __webpack_public_path__ + "img/attic-insulation.5d3afe1f.svg";